import { useNavigate } from 'react-router-dom'
import { Button, Input, Form, FormGroup, Label } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import { stringifyInputs } from '../CustomUtils'
import MonthInput from './MonthInput'

export default function AuditReportForm({ location }) {
  console.log('AuditReportForm rendered', location)

  let initialInputs = {
    fromMonthEndId: '',
    toMonthEndId: '',
    report: '1',
  }

  if (location) {
    // previous inputs
    const params = new URLSearchParams(location.search)
    initialInputs = JSON.parse(params.get('inputs'))
  }

  const navigate = useNavigate()
  const { inputs, handleInputChange, handleSubmit } = useForm(initialInputs, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('AuditReportForm.submitSearch', inputs)
    const url = `/custom/audit_report.audit_report?inputs=${stringifyInputs(inputs)}`
    navigate(url)
  }

  const options = []
  options.push(<option key={0} value={'1'}>Status Changed</option>)
  options.push(<option key={1} value={'6'}>Status Changed (not closed)</option>)
  options.push(<option key={2} value={'2'}>Diagnosis Changed</option>)
  options.push(<option key={3} value={'3'}>Date of First Exposure Changed</option>)
  options.push(<option key={4} value={'4'}>Court Location Changed</option>)
  options.push(<option key={5} value={'5'}>Exposure Changed</option>)
  options.push(<option key={6} value={'7'}>Diagnosis Changed to or from Mesothelioma</option>)
  options.push(<option key={7} value={'10'}>Diagnosis Changed to or from Mesothelioma (PDF)</option>)
  options.push(<option key={8} value={'8'}>Settlement Amount Changed</option>)
  options.push(<option key={9} value={'9'}>Positive Settlement Amount Changed</option>)

  return (
    <div style={{ textAlign: 'center'}}>
      <b>Please note: Settlement Amount Changed Audit Reports can be run to compare quarterly between 7-2-2006 and 09-29-2006 and, beginning in October 2006, for every month thereafter.</b><br/>
      <div style={{ display: 'inline-block', margin: '10px auto' }}>
        <Form inline className="plaintiff-search-form" onSubmit={handleSubmit}>
          <FormGroup className='mb-2 mr-sm-2 mb-sm-0'>
            <Label className='mr-sm-2'><b>Compare</b></Label>
            <MonthInput name='fromMonthEndId' handleChange={handleInputChange} end={false}/>
          </FormGroup>
          <FormGroup className='mb-2 mr-sm-2 mb-sm-0'>
            <Label className='mr-sm-2'><b>To</b></Label>
            <MonthInput name='toMonthEndId' handleChange={handleInputChange} end={true}/>
          </FormGroup>
          <FormGroup className='mb-2 mr-sm-2 mb-sm-0'>
            <Label className='mr-sm-2'><b>Showing</b></Label>
            <Input type='select' name='report' defaultValue={inputs.report} onChange={handleInputChange} multiple={false}>
              {options}
            </Input>
          </FormGroup>
          <Button className='plaintiff-search-button' color="primary">Run Report</Button>
        </Form>
      </div>
    </div>
  )
}